import { render } from "./ListeAdressePostalePage.vue?vue&type=template&id=0bc4a4c8&ts=true"
import script from "./ListeAdressePostalePage.vue?vue&type=script&lang=ts"
export * from "./ListeAdressePostalePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__